import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDm = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 25",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "DM",
		transform: "translate(0 6.5)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Combined-Shape",
				d: "M24,0V12.343H0V0ZM.686.686V11.657H23.314V.686Zm10.971,0h.686V11.657h-.686Z",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Combined-Shape_-_Outline",
				"data-name": "Combined-Shape - Outline",
				d: "M-.5-.5h25V12.843H-.5ZM11.157,1.186H1.186v9.971h9.971Zm11.657,0H12.843v9.971h9.971Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_993",
				"data-name": "Path 993",
				d: "M16.646,13.247a2.612,2.612,0,0,0-.569-1.906,1.861,1.861,0,0,0-1.365-.521H12.82v4.862h1.893a1.861,1.861,0,0,0,1.365-.521,2.629,2.629,0,0,0,.569-1.913Zm-.9,0a1.916,1.916,0,0,1-.35,1.365.962.962,0,0,1-.686.274H13.7V11.615h1.008a.962.962,0,0,1,.686.274,1.9,1.9,0,0,1,.35,1.358Z",
				transform: "translate(-8.425 -7.11)",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_994",
				"data-name": "Path 994",
				d: "M49.762,15.682V10.82H48.631l-1.282,3.463L46.073,10.82H44.88v4.862h.857V12.171l1.255,3.442h.651l1.262-3.4v3.47Z",
				transform: "translate(-29.493 -7.11)",
				fillRule: "evenodd"
			})
		]
	})
});
export default SvgIconDm;
